<div class="layout" [ngClass]="{'sidebar-collapsed': isSidebarCollapsed, 'sidebar-mobile-open': isSidebarMobileOpen}">
  @if (!isLoginPage) {
    <button class="mobile-menu-btn" (click)="toggleMobileSidebar()"
      [class.active]="isSidebarMobileOpen">
      <span></span>
      <span></span>
      <span></span>
    </button>
  }

  @if (!isLoginPage && isSidebarMobileOpen) {
    <div class="sidebar-overlay" (click)="closeMobileSidebar()">
    </div>
  }

  @if (!isLoginPage) {
    <app-sidebar [isMobileOpen]="isSidebarMobileOpen" (sidebarCollapsed)="onSidebarCollapsed($event)"
      [currentLanguage]="currentLanguage" (languageChanged)="changeLanguage($event)">
    </app-sidebar>
  }

  <div class="main-content" [ngClass]="{'login-layout': isLoginPage}">
    <router-outlet></router-outlet>
  </div>

  @if (!isLoginPage) {
    <app-modal-tutorial></app-modal-tutorial>
  }

  @if (isLoginPage) {
    <div class="app-footer-brand">
      <img [src]="footerLogo" alt="di2win">
    </div>
  }
</div>